<script lang="ts">
	import { website, ID2Page, ID2Slug } from '../../lib/content/configuration.gen.js';

	export let data;
</script>

<svelte:head>
	{#if data.metadata.ID == 'Static'}
		{@const url = new URL(data.metadata.pathname, website.metadata.baseURL).toString()}
		<title>{data.metadata.title} | {website.name}</title>
		<meta name="description" content={data.metadata.description} />
		<meta property="og:title" content={data.metadata.title} />
		<meta property="og:description" content={data.metadata.description} />
		<meta property="og:url" content={url} />
		<meta property="og:type" content="website" />
	{:else}
		{@const page = ID2Page[data.metadata.ID]}
		{@const description = page.metadata.description.length
			? page.metadata.description
			: website.metadata.description}
		{@const url = new URL(ID2Slug[page.ID], website.metadata.baseURL).toString()}
		<title>{page.name} | {website.name}</title>
		<meta name="description" content={description} />
		<meta property="og:title" content={page.metadata.title} />
		<meta property="og:description" content={description} />
		<meta property="og:url" content={url} />
		<meta property="og:type" content="website" />
		<!-- <meta property="og:image" content="" /> -->
		<!-- <meta property="og:image:alt" content="" /> -->
		<!-- <meta property="og:image:type" content="" /> -->
		<!-- <meta property="og:image:width" content="" /> -->
		<!-- <meta property="og:image:height" content="" /> -->
		<meta name="twitter:title" content={page.metadata.title} />
		<meta name="twitter:description" content={description} />
		<meta name="twitter:card" content="summary_large_image" />
		<!-- <meta name="twitter:image" content="" /> -->
		<!-- <meta name="twitter:image:alt" content="" /> -->
	{/if}
</svelte:head>

<svelte:component this={data.content} />
